// Keeps the address and the view-state store in step: the store starts from the
// address, every change rewrites the address (history.replaceState, so a slider
// drag does not fill the history), and Back or Forward reads the address again.
// Query parameters that are not view-state fields are kept as they are.

import { decodeViewState, encodeViewState, VIEW_STATE_KEYS } from "./url";
import type { ViewStore } from "./store";

/** The address that stands for the store's state, keeping foreign parameters and the hash. */
export function addressFor(store: ViewStore, location: Location = window.location): string {
  const foreign = new URLSearchParams(location.search);
  for (const key of [...foreign.keys()]) if (VIEW_STATE_KEYS.has(key)) foreign.delete(key);
  const rest = foreign.toString();
  const query = encodeViewState(store.state, store.views) + (rest === "" ? "" : `&${rest}`);
  return `${location.pathname}?${query}${location.hash}`;
}

/** Reads the address into the store, then mirrors the store into the address. Returns the unbind function. */
export function bindUrl(store: ViewStore): () => void {
  const read = (): void => {
    const { state, issues } = decodeViewState(window.location.search, store.views);
    for (const issue of issues) console.warn(`address: ${issue}`);
    store.replace(state);
  };
  const write = (): void => {
    const next = addressFor(store);
    const now = window.location.pathname + window.location.search + window.location.hash;
    if (next !== now) history.replaceState(history.state, "", next);
  };
  read();
  write();
  const unsubscribe = store.subscribe(write);
  window.addEventListener("popstate", read);
  return () => {
    unsubscribe();
    window.removeEventListener("popstate", read);
  };
}
